import { api } from 'data/api/api'

import { GetCatalogsResp } from 'types/api/response/get-catalogs-resp'
import { ProfileUserInfoResp } from 'types/api/response/profile-user-info-resp'
import { UploadAnotherItemTipResp } from 'types/api/response/upload-another-item-tip-resp'

import { GetUserItemFacetsArgs, ItemFacetsResp } from '../types/item-facets'
import { GetShowItemUploadFeedbackResp } from '../types/item-upload-feedback'
import { GetSellerFiltersResp } from '../types/seller-filters'

export const getCatalogs = () => api.get<GetCatalogsResp>('/catalogs')

export const getProfileUserInfo = (userId: number) =>
  api.get<ProfileUserInfoResp>(`users/${userId}/profile`)

export const getSellerFilters = () => api.get<GetSellerFiltersResp>('/closet/seller_filters')

export const getShowItemUploadFeedback = () =>
  api.get<GetShowItemUploadFeedbackResp>('/items/show_upload_feedback')

export const getUploadAnotherItemTip = (itemId: number) =>
  api.get<UploadAnotherItemTipResp>('/item_upload/upload_another_item_tip', {
    params: { item_id: itemId },
  })

export const getUserItemFacets = ({ userId }: GetUserItemFacetsArgs) =>
  api.get<ItemFacetsResp>(`/users/${userId}/item_facets`)
